// extracted by mini-css-extract-plugin
export default {"modalRoot":"partners-notifier_modalRoot__KQWYb","modalFooter":"partners-notifier_modalFooter__MeMaI","footerButton":"partners-notifier_footerButton__zVsiC"};